<app-dossier eyebrow="Contrôle d'identité // Accès">
  <app-state-panel kind="loading" title="Vérification de votre accès…" />
</app-dossier>
